module.exports = __webpack_public_path__ + "img/missionaries7_2019_7-7-2021.faf4bb78.jpg";